import React from 'react';
import { useSelector } from 'react-redux';

import { FlyoutProvider } from 'components/Flyout/FlyoutContext';
import { IA_KEY } from 'helpers/ia-logic';
import { selectActiveVenue, selectIaLogic } from 'selectors/general';

import { ItemFormProvider } from './components/ItemFormContext';
import Items from './Items';
import SkuMenuPage from './SkuMenuPage';

const ItemsWithProviders = props => {
  const { venueId } = useSelector(selectActiveVenue);
  const { featureIsSupported: skuItemsSupported } = useSelector(state =>
    selectIaLogic(state, IA_KEY.SKU_ITEM_MANAGEMENT, venueId)
  );

  if (skuItemsSupported) {
    return <SkuMenuPage {...props} />;
  }

  return (
    <FlyoutProvider>
      <ItemFormProvider>
        <Items {...props} />
      </ItemFormProvider>
    </FlyoutProvider>
  );
};

export default ItemsWithProviders;
